import { CONFIG } from '../config/constant';

/**
 * @description Handle Redirects to Clever login page.
 */
function cleverLoginRedirect() {
  if (typeof window !== 'undefined') {
    const a = CONFIG.loginLink[process.env.REACT_APP_NODE_ENV || 'development'];
    console.log('Redirection to', a);
    window.location.href = a;
  }
}

/**
 * @description Handle Redirects to Clever login page.
 * 1. Remove the user from local storage.
 * 2. Redirect to Clever login page. with cleverLoginRedirect()
 * @example
 * if (!isAuthenticated) return signOutHandler();
 */
export function signOutHandler() {
  if (typeof window !== 'undefined') {
    localStorage && localStorage.removeItem('me');
    cleverLoginRedirect();
  }
}
